import miWear from "@mi/miwear-jssdk"
import Base from "./base"
import { getQuery } from "./browser"
import { setDir } from "./dom"

export enum PrivacyType {
  Privacy = "watch_privacy_policy",
  License = "watch_user_license",
  Information = "user_info_privacy",
  Location = "gps_privacy",
  Experience = "watch_user_exp"
}

const models = [
  ["midr.watch.k65", "midr.watch.k62", "midr.watch.k63","midr.watch.k63a","midr.watch.k62a"]
]

class Privacy extends Base {
  type: string

  constructor() {
    super()
    this.type = getQuery("type")
    this.model = this.model || "xiaomi.watch.mars"

    if (this.type === 'wear_user_privacy' || this.type === 'watch_user_privacy') {
      console.warn(
        `隐私政策的type字段请使用watch_privacy_policy, ${this.type}仅作为别名`,
      );
      this.type = PrivacyType.Privacy;
    }

    // 对隐私政策、手机用户信息、地理位置 协议，app 和 app_lite 统一用一套
    if ([PrivacyType.Privacy, PrivacyType.Information, PrivacyType.Location].some(t => t === this.type) && this.model === "app_lite") {
      this.model = "app"
    }

    // 处理部分产品隐私政策共用的逻辑
    if (this.type === PrivacyType.Privacy) {
      const m = models.find(t => t.includes(this.model))
      if (m) {
        this.model = m[0]
      }
    }
  }

  async load() {
    if (!this.region) {
      try {
        this.region = await miWear.getAppRegion()
      } catch (err) {
        console.error(err)
      }
    }
    const map = await this.loadConfig("privacy")
    let list: Array<string> = []
    const res = map[this.type]
    if (res instanceof Array) {
      list = res
    } else {
      list = res[this.model] || []
    }
    this.supportedLocale = [this.locale, this.fallback].find(t => list.includes(t)) || 'en'
    setDir(this.supportedLocale)
    return list
  }
}

export default new Privacy()
